export const GET_TRANSACTION = 'DEATH_CERTIFICATES/get_transaction';
export const APPROVE_TRANSACTION = 'DEATH_CERTIFICATES/approve_transaction';
export const UPDATE_TRANSACTION = 'DEATH_CERTIFICATES/update_transaction';
export const SHOW_TRANSACTION = 'DEATH_CERTIFICATES/show_transaction';
export const START_ASSESSMENT = 'DEATH_CERTIFICATES/start_assessment';
export const GET_SETTINGS = 'DEATH_CERTIFICATES/get_settings';
export const UPDATE_TEST_STATUS = 'DEATH_CERTIFICATES/update_health_status';
export const GET_DEATH_ARCHIVE =
  'DEATH_CERTIFICATES/get_DEATH_CERTIFICATES_archive';
export const GET_PHOTO = 'DEATH_CERTIFICATES/getPhoto';
export const ASSESS_RECEIPT = 'DEATH_CERTIFICATES/assess_receipt';
export const EDIT_BIRTH = 'DEATH_CERTIFICATE/edit_birth';
export const UPDATE_REGISTRY = 'DEATH_CERTIFICATE/update_registry';
export const MANUAL_PAYMENT_APPROVE =
  'DEATH_CERTIFICATE/manual_payment_approve';
export const MANUAL_PAYMENT_REJECT = 'DEATH_CERTIFICATE/manual_payment_reject';
export const GET_LOGS = 'DEATH_CERTIFICATE/get_logs';

export const QR_VERIFIER = 'DEATH_CERTIFICATE/qr_verifier';
export const APPLY_DISCOUNT = 'DEATH_CERTIFICATE/apply_discount';
export const CANCEL_APPLICATION = 'DEATH_CERTIFICATE/cancel_application';
export const CANCEL_ASSESSMENT = 'DEATH_CERTIFICATE/cancel_assessment';
export const GET_PURPOSE_LIST = 'BIRTH_CERTIFICATE/get_purpose_list';

export const FORM_DATA = {
  // Owner's Personal Information
  registry_number: '',
  first_name: '',
  middle_name: '',
  last_name: '',
  extension_name: '',
  gender: '',
  death_date: '',
  hospital_code: '',
  hospital_other: '',

  // Requestor's Information
  requestors_first_name: '',
  requestors_middle_name: '',
  requestors_last_name: '',
  requestors_extension_name: '',
  relationship_to_the_owner: '',

  // Mailing Address
  region_code: '',
  province_code: '',
  municipality_code: '',
  barangay_code: '',
  street: '',
  mailing_zip_code: '',
  telephone_number: '',
  mobile_number: '',

  // Transactional Information
  number_of_copies: '',
  what_to_print: '',
  valid_id_to_present: 'OTHER',
  purpose_code: '',
  purpose_specify: '',
  purpose_country_code: '',

  // NEED FOR VALIDATION ONLY
  place_of_death_municipality_code: '',
};
